import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '电影分类',
    links: [
      { label: '动作片', path: '/category/action' },
      { label: '喜剧片', path: '/category/comedy' },
      { label: '科幻片', path: '/category/scifi' },
      { label: '剧情片', path: '/category/drama' },
      { label: '恐怖片', path: '/category/horror' },
      { label: '动画片', path: '/category/animation' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { label: '电影排行榜', path: '/category/all' },
      { label: '最新电影', path: '/category/all' },
      { label: '高分经典', path: '/category/drama' },
      { label: '影评文章', path: '/category/all' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about' },
      { label: '用户口碑', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/30">
      <div className="px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2.5 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/20 border border-primary-500/30">
                  <i className="ri-movie-2-fill text-primary-400 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-50">花生影院</span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                花生影院致力于为广大影迷提供最新、最全的电影资源信息，打造一站式电影服务平台。高清不缓冲，让你畅享观影体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-300" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-300" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-300" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-foreground-200 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; 2025 花生影院 Huasheng Cinema. 本站为非营利性电影资源导航网站，所有内容仅供学习交流。
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">服务条款</a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}